import { Backup } from 'model';
import { BaseApi } from './BaseAPI';

const baseURL = 'backups/';

export const BackupApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		getBackupsForDocument: builder.query<Backup[], { id: string }>({
			query: ({ id }: { id: string }) => ({
				url: `${baseURL}${id}`,
				method: 'GET'
			}),
			providesTags: (result, error, arg) => result?.map(({ _id }) => ({ type: 'Backup', id: _id })) ?? []
		})
	})
});

export const { useGetBackupsForDocumentQuery } = BackupApi;
